import { UploadImage } from '../../../../../../components/upload-image';
import './styles.scss';

export const CoverPhoto = ({cover}) => (
  
  <div className="cover-photo">
    <p className="cover-photo__title">Copertina</p>
    <UploadImage fieldName="banner" image={cover}/>
  </div>
)